module.exports = __webpack_public_path__ + "img/2_256.f26ffc5f.png";